import { BillingPlanMapping } from '@/modules/billing/models/BillingPlanMapping';
import { BaseWorkflowRule } from '@/modules/workflow/models/BaseWorkflowRule';

export class WorkflowBillingPlanRule extends BaseWorkflowRule {
  id?: number;

  billingPlanMappingId?: number;

  billingPlanMapping?: Relationship<BillingPlanMapping>;

  constructor(model: Partial<WorkflowBillingPlanRule> = {}) {
    super(model);

    this.id = model.id;
    this.billingPlanMappingId = model.billingPlanMappingId;
    this.billingPlanMapping =
      BillingPlanMapping.mapModelOrNull(model.billingPlanMapping) || undefined;
  }

  get ruleId(): string | undefined {
    return this.billingPlanMappingId?.toString();
  }

  toString(): string {
    return this.billingPlanMapping?.planName ?? '';
  }
}
